export default "__VITE_ASSET__CzX7Rqx8__"